// @ts-nocheck
import React, { useState, useEffect, useContext, useRef } from 'react';
import Router from 'next/router';
import TextInput from '@/components/text-input';
import TextArea from '@/components/text-area';
import Button from '@/components/button';
import Breadcrumbs from '@/components/breadcrumbs';
import { colors, fontSizes, layout, fontFamily, shadows } from '@/theme';
import Fetch from '@/utils/Fetch';
import RolePermissions from '@/components/modals/role-permissions';
import ToastContext from '@/utils/toast-context';
import SettingsMenu from '@/components/settings/menu';
import Helper from '@/utils/helper';
import ConfirmAction from '@/components/modals/confirm-action';
import Storage from '@/utils/storage';
import * as Enums from '@/utils/enums';
import constants from '@/utils/constants';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'



function RoleSettings() {
  const toast = useContext(ToastContext);
  const { data: rolesData } = useQuery(['roles'], () => Fetch.get({ url: '/Role' }));
  const [roles, setRoles] = useState<any[]>([]);
  const { data: permissionsData } = useQuery(['permissions'], () => Fetch.get({ url: '/Permission' }));
  const [permissions, setPermissions] = useState<any[]>([]);

  useEffect(() => {
    if (rolesData?.Results) {
      setRoles(rolesData.Results);
    }
  }, [rolesData]);

  useEffect(() => {
    if (permissionsData?.Results) {
      setPermissions(permissionsData.Results);
    }
  }, [permissionsData]);
  const [submitting, setSubmitting] = useState(false);
  const [selectedRole, setSelectedRole] = useState<any>();
  const [roleName, setRoleName] = useState<any>();
  const [roleDescription, setRoleDescription] = useState<any>();
  const [rolePermissions, setRolePermissions] = useState<any>();
  const [addingPermissions, setAddingPermissions] = useState(false);
  const [showPicker, setShowPicker] = useState(false);

  const [formIsDirty, setFormIsDirty] = useState(false);
  const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  }

  useEffect(() => {
    getAccessStatus();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace,"/");
    }
  }, [accessStatus]);

  Helper.preventRouteChange(formIsDirty, setFormIsDirty, setConfirmOptions, updateRole);

  let currPath = "";
  if (Router.router) {
    currPath = Router.router.asPath;
  }

  //SUBMIT Updates
  async function updateRole() {
    setSubmitting(true);

    let settingsUpdateResult;
    if (selectedRole.ID) {
      settingsUpdateResult = await Fetch.put({
        url: '/Role',
        params: {
          ...selectedRole,
          Name: roleName,
          Description: roleDescription,
          Permissions: rolePermissions
        },
        toastCtx: toast
      });

      if (settingsUpdateResult) {
        setFormIsDirty(false);
        toast.setToast!!!({
          message: 'Role updated successfully',
          show: true,
          type: 'success'
        })
      }
    } else {
      settingsUpdateResult = await Fetch.post({
        url: '/Role',
        params: {
          Name: roleName,
          Description: roleDescription,
          IsActive: true,
          Permissions: rolePermissions
        },
        toastCtx: toast
      });

      if (settingsUpdateResult) {
        Helper.mixpanelTrack(constants.mixPanelEvents.createRole, {
          "roleID": settingsUpdateResult.ID
        });
        setFormIsDirty(false);
        toast.setToast!!!({
          message: 'Role created successfully',
          show: true,
          type: 'success'
        })
      }
    }

    if (settingsUpdateResult) {
      setFormIsDirty(false);
      toast.setToast!!!({
        message: 'Status updated successfully',
        show: true,
        type: 'success'
      })
    }

    const roles = await Fetch.get({
      url: '/Role'
    });

    setRoles(roles.Results)
    setSelectedRole(undefined);
    setSubmitting(false);
    return true;
  }

  async function deleteRole() {
    setSubmitting(true);

    if (selectedRole.ID) {
      const deleteResult = await Fetch.destroy({
        url: '/Role/' + selectedRole.ID,
        params: {},
        toastCtx: toast
      });

      if (deleteResult) {
        setFormIsDirty(false);
        toast.setToast!!!({
          message: 'Role deleted successfully',
          show: true,
          type: 'success'
        })
      }
    }

    const roles = await Fetch.get({
      url: '/Role'
    });

    setRoles(roles.Results)
    setSelectedRole(undefined);
    setSubmitting(false);
  }

  function newRole() {
    setSelectedRole({
      Description: "Description of role",
      Name: "New Role",
      Permissions: []
    });
    setFormIsDirty(true);
  }

  function savePermissions(newPermissions: any) {
    setRolePermissions(newPermissions)
    setAddingPermissions(false);
    setFormIsDirty(true);
  }

  useEffect(() => {
    if (selectedRole) {
      setFormIsDirty(false);
      setRoleName(selectedRole.Name)
      setRoleDescription(selectedRole.Description)
      setRolePermissions(selectedRole.Permissions)
    }
  }, [selectedRole]);

  return (
    <div className="container">
      <div className="row">
        <SettingsMenu urlPath={currPath} />
        <div className="column">
          <h2>Role Settings</h2>
          <div className="section-title">
            Employee Roles
          </div>
          <div className="small-title">Current roles</div>
          <div className={`statuses`}>
            {roles.map(function (role: any, index: any) {
              return (
                <div className={`status-container`} onClick={() => setSelectedRole(role)} key={index}>
                  <div className={`status`}>
                    {role.Name}
                  </div>
                </div>
              )
            })}
            <div className="status-container status-add">
              {accessStatus !== Enums.AccessStatus.LockedWithAccess && accessStatus !== Enums.AccessStatus.LockedWithOutAccess ? <>
                <div className="status" onClick={newRole}>
                  <img src="/icons/plus-circle.svg" alt="plus" />
                Add Role
              </div>
              </> : ""}
            </div>
          </div>
          {selectedRole
            ? <div className="status-setup">
              <h1>Role set up</h1>
              {accessStatus !== Enums.AccessStatus.LockedWithAccess && accessStatus !== Enums.AccessStatus.LockedWithOutAccess ? <>
                <img src="/icons/trash-white.svg" alt="delete" onClick={deleteRole} className="delete" />
              </> : ""}
              <Button disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess}
                text={submitting ? "Saving" : "Save"} extraClasses="white fit-content save" onClick={updateRole} />
              <div className="detail-row">
                <div className="detail-column">
                  <div className="small-title">Role name</div>
                  <TextInput
                    changeHandler={(e: any) => setRoleName(e.target.value)}
                    name="roleName"
                    placeholder={"Enter the name of the role"}
                    value={roleName}
                  />
                  <div className="small-title">Role Description</div>
                  <TextArea
                    changeHandler={(e: any) => setRoleDescription(e.target.value)}
                    name="roleDescription"
                    placeholder={"Enter the description of the role"}
                    value={roleDescription}
                  />
                </div>
              </div>
              <div className="small-title">Permissions for role</div>
              <div className="status-options">
                {rolePermissions && rolePermissions.map(function (permission: any, index: any) {
                  return (
                    <div key={index} className="permission">
                      {permission.Name}
                    </div>
                  )
                })}
                <Button disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess}
                  text="Edit permissions" onClick={() => setAddingPermissions(true)} />
              </div>
              {addingPermissions
                ? <RolePermissions
                  availablePermissions={permissions}
                  currentPermissions={rolePermissions}
                  setAddingPermissions={setAddingPermissions}
                  savePermissions={savePermissions}
                />
                : ""
              }
            </div>
            : ""
          }
        </div>
      </div>

      <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />

      <style jsx>{`
        .container {
          background-color: ${colors.blueDark};
          border-top-left-radius: ${layout.bodyRadius};
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          height: 100%;
          padding: 1.5rem 2rem;
          overflow-x: hidden;
        }
        .column {
          display: flex;
          flex-direction: column;
          width: 100%;
        }
        .column-margin {
          margin-left: 24px;
        }
        p {
          color: ${colors.white};
        }
        .button-container {
          flex-shrink: 0;
          width: 10rem;
        }
        .button-container :global(.button){
          margin-top: 0.5rem;
        }
        .title {
          width: 100%;
          color: ${colors.white};
        }
        .title h1 {
          font-size: 24px;
          margin: 6px 0 2rem 0;
        }
        .title p {
          font-size: 14px;
          margin: 0;
        }
        .row {
          display: flex;
        }
        .space-between {
          justify-content: space-between;
        }
        .split {
          display: flex;
        }
        .detail-row {
          display: flex;
          margin-left: -1.5rem;
        }
        .detail-column {
          display: flex;
          flex-direction: column;
          flex-grow: 1;
          margin-left: 1.5rem;
          max-width: 50%;
        }
        h2 {
          color: ${colors.white};
          font-size: 1.75rem;
          font-weight: lighter;
          margin: 1rem 0 1rem;
        }
        .section-title {
          background-color: ${colors.background};
          border-radius: ${layout.cardRadius};
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          color: ${colors.bluePrimary};
          font-size: 1.25rem;
          font-weight: bold;
          opacity: 0.9;
          padding: 1rem;
        }
        .small-title {
          color: ${colors.white};
          font-size: 0.875rem;
          font-weight: bold;
          margin-top: 2rem;
        }
        .status {
          align-items: center;
          border-radius: ${layout.buttonRadius};
          box-sizing: border-box;
          color: ${colors.bluePrimary};
          cursor: pointer;
          display: flex;
          font-size: 0.875rem;
          font-weight: bold;
          height: 3rem;
          justify-content: center;
          padding: 0 1rem;
          text-align: center;
        }
        .status-container {
          background-color: ${colors.white};
          border-radius: ${layout.buttonRadius};
          height: 3rem;
          margin: 1rem 0 0 1rem;
          width: calc(25% - 1rem);
        }
        .statuses {
          display: flex;
          flex-wrap: wrap;
          margin: 0 0 0 -1rem;
        }
        .status-add {
          background: none;
          border: 1px solid ${colors.white};
          box-sizing: border-box;
        }
        .status-add img {
          margin-right: 0.5rem;
        }
        .status-add .status {
          background: none;
          color: ${colors.white};
        }
        .status-setup {
          border: 1px solid rgba(255, 255, 255, 0.7);
          border-radius: ${layout.cardRadius};
          margin-top: 1.5rem;
          padding: 1rem;
          position: relative;
        }
        .status-setup h1 {
          color: ${colors.white};
          font-size: 1.5rem;
          font-weight: normal;
          margin: 0 0 -0.5rem;
        }
        .status-setup :global(.save) {
          margin-top: 0px;
          position: absolute;
          right: 1rem;
          top: 1rem;
        }
        .status-setup :global(.delete) {
          cursor: pointer;
          margin-top: 0px;
          position: absolute;
          right: 6.5rem;
          top: 1.5rem;
        }
        .status-options {
          width: 50%;
        }
        
        .permission {
          color: ${colors.white};
          margin-top: 0.5rem;
        }

      `}</style>
    </div>
  );
}

export default RoleSettings

export const Route = createFileRoute('/_authenticated/settings/role-settings')({ component: RoleSettings })
